module.exports = __webpack_public_path__ + "static/trees-right-footer-eae932fbaf6cd74ce2aceceb3c130433.png";